import { extractProductsFromProductsList } from "../utils/ff8-product-list-helpers";
import { domReadyLegacy } from "./../utils/ready";
import { analyticsReady } from "../utils/ready";
import { analyticsTrack } from "../utils/analytics";

type FilterType = { type: string; value: string };

let APPLIED_FILTERS: Array<FilterType> = [];

function addAppliedFilter(filter: FilterType) {
  APPLIED_FILTERS.push(filter);
  return APPLIED_FILTERS;
}

function removeAppliedFilter(filter: FilterType) {
  for (let i = 0; i < APPLIED_FILTERS.length; i++) {
    const item = APPLIED_FILTERS[i];
    if (item.type == filter.type && item.value == filter.value) {
      APPLIED_FILTERS.splice(i, 1);
    }
  }

  return APPLIED_FILTERS;
}

function applyFiltersFromInput(input: HTMLInputElement, filter: FilterType) {
  if (input.checked) {
    return addAppliedFilter(filter);
  } else {
    return removeAppliedFilter(filter);
  }
}

function getValueFromInput(input: HTMLInputElement) {
  return input.parentElement?.textContent?.replace(/\(.*\)$/, "")?.trim();
}

function listenForChecks(input: [HTMLDivElement, string, string]) {
  const [containerElement, _category, filterType] = input;

  if (!containerElement) {
    return;
  }

  const inputs = containerElement.querySelectorAll<HTMLInputElement>(
    "input[type=checkbox][checked=checked]"
  );

  inputs.forEach((input) => {
    const value = getValueFromInput(input);

    if (value == null) {
      return;
    }

    const filter = { type: filterType, value };

    applyFiltersFromInput(input, filter);
  });
}

async function trackFilterEvent(filters: FilterType[], category: string) {
  await analyticsReady();

  analyticsTrack("Product List Filtered", {
    application: "ff8",
    category,
    filters,
    products: extractProductsFromProductsList(document.body),
  });
}

async function trackViewedEvent(category: string) {
  await analyticsReady();

  analyticsTrack("Product List Viewed", {
    category,
    products: extractProductsFromProductsList(document.body),
  });
}

function extractProductCategoryFromPathname() {
  const results = location.pathname.match(/^\/all-(.*)-flooring$/);

  return results && results[1];
}

function installTracking() {
  APPLIED_FILTERS = [];

  const filterElements = document.querySelectorAll<HTMLDivElement>(
    "div[class*=_filters_]"
  );

  const flooringCategory = extractProductCategoryFromPathname();

  if (flooringCategory == null) {
    return;
  }

  const filterTypes: Array<[HTMLDivElement, string, string]> = [];

  filterElements.forEach((elem) => {
    if (elem.className.match(/desktop_filters_adaptive/)) {
      return;
    }

    elem.classList.forEach((className) => {
      const matches = className.match(/(.*)_filters_(.*)$/);

      if (matches) {
        const [_, category, filterType] = matches;
        filterTypes.push([elem, category, filterType]);
      }
    });
  });

  filterTypes.map(listenForChecks);

  if (APPLIED_FILTERS.length > 0) {
    trackFilterEvent(APPLIED_FILTERS, flooringCategory);
  } else {
    trackViewedEvent(flooringCategory);
  }
}

export function install(): void {
  domReadyLegacy(installTracking);
}
